export default __webpack_public_path__ + "static/media/person-add-black-small.cbcee4b1.svg";